const isOak = (seed) => seed?.startsWith("oak");

function Soil() {
  return <ellipse cx="30" cy="54" rx="14" ry="4.5" fill="#4a2f1b" opacity="0.8" />;
}

function SeedArt() {
  return (
    <g>
      <Soil />
      <ellipse cx="30" cy="52" rx="8" ry="3" fill="#6b4426" />
      <circle cx="27" cy="51" r="1.6" fill="#e6c48a" />
      <circle cx="33" cy="52" r="1.6" fill="#e6c48a" />
    </g>
  );
}

function SproutArt() {
  return (
    <g>
      <Soil />
      <path d="M30 54 L30 42" stroke="#4caf50" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M30 46 Q22 40 19 44 Q24 49 30 46Z" fill="#7bd36b" />
      <path d="M30 44 Q38 37 41 41 Q36 47 30 44Z" fill="#5fc157" />
    </g>
  );
}

function GrowingArt({ seed }) {
  if (isOak(seed)) {
    return (
      <g>
        <Soil />
        <rect x="27.5" y="34" width="5" height="20" rx="2" fill="#7a4b2a" />
        <circle cx="30" cy="30" r="11" fill="#3f9b4f" />
        <circle cx="23" cy="34" r="6" fill="#4fb35c" />
        <circle cx="37" cy="34" r="6" fill="#4fb35c" />
      </g>
    );
  }
  const bud = seed === "golden-berry" ? "#b07cff" : seed === "corn" ? "#d7e86a" : "#d9e27a";
  return (
    <g>
      <Soil />
      {[21, 30, 39].map((x, i) => (
        <g key={x}>
          <path d={`M${x} 55 Q${x + (i - 1) * 2} 44 ${x} ${32 + (i % 2) * 4}`} stroke="#3e9a46" strokeWidth="2.6" fill="none" strokeLinecap="round" />
          <path d={`M${x} ${44} Q${x - 7} ${39} ${x - 8} ${43}`} stroke="#5cbf55" strokeWidth="2.2" fill="none" strokeLinecap="round" />
          <circle cx={x} cy={31 + (i % 2) * 4} r="2.6" fill={bud} />
        </g>
      ))}
    </g>
  );
}

function WheatReady() {
  return (
    <g>
      <Soil />
      {[16, 22, 28, 34, 40, 45].map((x, i) => (
        <g key={x}>
          <path d={`M${x} 55 Q${x + 2} 40 ${x + (i % 2 ? 3 : -2)} 22`} stroke="#d4a72c" strokeWidth="2" fill="none" />
          {[0, 1, 2, 3].map((k) => (
            <ellipse key={k} cx={x + (i % 2 ? 3 : -2) + (k % 2 ? 1.6 : -1.6)} cy={23 + k * 3.2} rx="1.8" ry="2.8"
              fill={k % 2 ? "#ffd84d" : "#f2b822"} />
          ))}
        </g>
      ))}
    </g>
  );
}

function CornReady() {
  return (
    <g>
      <Soil />
      {[20, 40].map((x) => (
        <g key={x}>
          <path d={`M${x} 55 L${x} 14`} stroke="#2f8f3a" strokeWidth="3.4" strokeLinecap="round" />
          <path d={`M${x} 42 Q${x - 12} 34 ${x - 14} 40`} stroke="#3fae48" strokeWidth="3" fill="none" strokeLinecap="round" />
          <path d={`M${x} 30 Q${x + 12} 22 ${x + 14} 28`} stroke="#3fae48" strokeWidth="3" fill="none" strokeLinecap="round" />
          <ellipse cx={x + 4.5} cy="34" rx="4.2" ry="9" fill="#ffd400" stroke="#f0a500" strokeWidth="1" />
          <path d={`M${x + 1} 42 Q${x + 4} 30 ${x + 2} 26`} stroke="#5cc24e" strokeWidth="2" fill="none" />
          <path d={`M${x} 14 l-3 -5 M${x} 14 l3 -5`} stroke="#e8c95a" strokeWidth="1.5" />
        </g>
      ))}
    </g>
  );
}

function BerryReady() {
  return (
    <g>
      <Soil />
      <ellipse cx="30" cy="42" rx="19" ry="13" fill="#5b2a86" />
      <ellipse cx="24" cy="38" rx="10" ry="8" fill="#7a3db3" />
      <ellipse cx="37" cy="40" rx="9" ry="7" fill="#6c34a0" />
      {[[19, 39], [28, 33], [38, 36], [24, 46], [35, 47], [31, 41]].map(([x, y]) => (
        <g key={`${x}-${y}`}>
          <circle cx={x} cy={y} r="5" fill="#ffd54a" opacity="0.35" />
          <circle cx={x} cy={y} r="3.2" fill="#ffc72c" stroke="#fff3b0" strokeWidth="0.8" />
        </g>
      ))}
    </g>
  );
}

function OakReady() {
  return (
    <g>
      <Soil />
      <rect x="26" y="30" width="8" height="25" rx="2.5" fill="#7a4b2a" />
      <circle cx="30" cy="21" r="16" fill="#2f8a45" />
      <circle cx="18" cy="28" r="9" fill="#3fa356" />
      <circle cx="42" cy="28" r="9" fill="#3fa356" />
      {[[22, 16], [36, 14], [30, 26], [16, 30], [44, 30]].map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="3.3" fill="#ff7a1a" stroke="#ffc72c" strokeWidth="1" />
      ))}
    </g>
  );
}

function WitheredArt() {
  return (
    <g>
      <ellipse cx="30" cy="54" rx="14" ry="4.5" fill="#3d2a1c" />
      <path d="M22 54 Q20 44 13 43" stroke="#8a6a3e" strokeWidth="2.6" fill="none" strokeLinecap="round" />
      <path d="M30 54 Q31 41 39 39" stroke="#7a5c34" strokeWidth="2.6" fill="none" strokeLinecap="round" />
      <path d="M36 54 Q41 48 46 50" stroke="#8a6a3e" strokeWidth="2.6" fill="none" strokeLinecap="round" />
      <path d="M38 39 l3 3 M14 43 l-2 3" stroke="#6b4f2c" strokeWidth="2" strokeLinecap="round" />
    </g>
  );
}

const READY = { wheat: WheatReady, corn: CornReady, "golden-berry": BerryReady };

export const CropArt = ({ seed, stage }) => {
  if (stage === "seed") return <SeedArt />;
  if (stage === "sprout") return <SproutArt />;
  if (stage === "growing") return <GrowingArt seed={seed} />;
  if (stage === "withered") return <WitheredArt />;
  if (stage === "ready") {
    const R = isOak(seed) ? OakReady : READY[seed] || WheatReady;
    return <R />;
  }
  return null;
};

export const CropSprite = ({ seed, stage, size = 60 }) => (
  <svg width={size} height={size} viewBox="0 0 60 60" className="drop-shadow-[0_4px_4px_rgba(0,0,0,0.45)]">
    <CropArt seed={seed} stage={stage} />
  </svg>
);
